import React, { useState,useEffect } from "react";
import "./privacy&CookiesPage.css";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/userContext";
import { useCart } from "../../contexts/cartContext";

const PrivacyAndCookiesPage = () => {
  const navigate = useNavigate()
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
  const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage } =
    useUser();
    const { fetchCartQuantity,cartQuantity,setCartQuantity ,handleQuantity} = useCart();
    const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId,fetchCsrfToken } = useUser();
  useEffect(() => {
    fetchSeoMetaDetails()
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem('categoryId');
    sessionStorage.removeItem('productId');

   
  }, []);

  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;
  
    // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
  }, []);

  const fetchSeoMetaDetails = async () => {
    try {
        const code = 'privacy_policy_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json"
            },
            credentials: "include",
            mode:"cors"                   
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  return (
    <div>
      <Header />
      <main className="main-content-privacy-cookies-page">
      <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a >Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
        <div className="container mt-5-">
          <div className="privacy-cookies-section">
            <h2>Privacy Policy</h2>
            <p>
              This website www.selsmart.in (“<strong>Website</strong>”) is
              operated and owned by Attero Recycling Private Limited (“
              <strong>We</strong>”, “<strong>Our</strong>” “<strong>Us</strong>
              ”), a company incorporated under the laws of India, having its
              registered office at 2, C/o Saraswati Press, Green Park, Dehradun
              248001, Uttarakhand, India and corporate office at A-72/A,
              Sector-64, Noida 201301, Uttar Pradesh, India
            </p>
            <p>
              This Privacy Policy is an electronic record in the form of an
              electronic contract as per the Information Technology Act, 2000
              and rules made thereunder (as amended from time to time) and does
              not require any physical or digital signature.
            </p>
            <p>
              We respect the privacy of Our users (“<strong>You</strong>
              ”, “<strong>Your</strong>”, “<strong>Yours</strong>
              ”) and We are fully committed to protect Your privacy while
              ensuring the security of Your Personal Information.
            </p>
            <p>
              This Privacy Policy outlines how We collect, use, share, protect
              and process Your Personal Information, each time You visit Our
              Website. While You can browse certain privacy-cookies-sections of
              the Website without registering Yourself, please note that Our
              services are only available in India. Your Personal Information
              will primarily be stored and processed in India, under the
              applicable data protection laws which may be different than the
              country You are located in.
            </p>
          </div>
          <div className="privacy-cookies-section">
            <h3>Acknowledgement</h3>
            <p>
              Please read this Privacy Policy before using Our Website. By using
              Our Website, providing Your Personal Information or by availing
              any services offered through the Website, You expressly agree to
              the terms and conditions of this Privacy Policy, the Terms and
              Conditions, Shipping Policy and Cancellation Policy, and be
              governed under the applicable laws of India. If You don’t agree to
              these terms, please do not use Our Website.
            </p>
            <p>
              You understand and agree that when You access Our Website, You may
              be redirected to third-party domains that are not owned or managed
              by Us, You will be subjected to the terms and conditions and
              privacy policy of that third-party domains. If You use or access
              third party domains, We will not be held responsible for any
              claims that You make to Us.
            </p>
            <p>
              We reserve the right, at any time and without prior notice to You,
              to update, revise, or alter this Privacy Policy. Any such
              revision, correction, or modification will become effective as
              soon as it is published on the Website. We request You to check
              this Privacy Policy from time to time.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Information that we may Collect from you</h3>
            <p>
              While using Our Website, We may ask You to provide Us with Your
              Personal Information that can be used to contact or identify You.
              We collect Your Personal Information only if it is required for Us
              to provide You with Our services.
            </p>
            <p>
              For the purpose of this Privacy Policy, Personal Information mean
              any information that is related to You and which is either
              directly or indirectly capable of identifying You and including
              but not limited to Your: (a) Name; (b) password; (c) phone number;
              (d) email Id; (e) financial information such as Bank account or
              credit card or debit card or other payment instrument details; and
              (f) residential address.
            </p>
            <p>
              We also collect and process certain non-Personal Information
              automatically when You use Our Website. For the purpose of this
              Policy, non-Personal Information may include but is not limited
              to:
            </p>
            <h4>1. User Data:</h4>
            <p>
              We collect information about how You use Our Website, types of
              content that You view, the features You use, Your searches &
              results, Your browsing information, the actions You take and the
              time, frequency and duration of Your activity. The last website or
              the URL from where You were redirected to Our Website.
            </p>
            <h4>2. Device Information:</h4>
            <p>
              {" "}
              We collect information about the electronic device You use to
              access Our Website. Device information may include Your geographic
              location, internet connection, IP address, operating systems,
              browsing information, device type, unique device identifier,
              network information, metadata and other information.
            </p>
            <h4>3. Information from third parties:</h4>
            <p>
              We may also obtain information about You from partnered third
              parties and researchers to serve ads on Our behalf across the
              internet and sometimes on Our Website. Third-party service
              providers may collect information about Your visits to the
              Website, and Your interaction with the services on the Website.
            </p>
            <h4>4. Location Information:</h4>
            <p>
              We may collect Your geographic information or Your current
              location to provide You Our services.
            </p>
            <h4>5. Cookies and other Electronic Tools:</h4>
            <p>
              Our Website uses cookies, pixel tags, and similar technologies to
              collect information about Your browsing activity. These
              technologies help Us remember Your preferences and improve Your
              overall experience on Our Website. You can erase or choose to
              disable/block these cookies through Your Device/browser settings.
              If You have turned cookies off, You may be prevented from using
              certain features of the Website and this may interfere with
              certain functionality of the Website. Please note that We or any
              of Our partners or affiliates will never ask for Your Personal
              Information like debit/credit card PIN, net banking passwords via
              email or SMS or phone call.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>
              Purpose of Collection Storage, Processing of your Information
            </h3>
            <p>
              Your Personal and non-Personal Information will be stored in
              electronic form however certain data may be stored in physical
              form to provide You Our services, including processing
              transactions, fulfilling orders, and providing customer support.
              We may store Your Personal Data in India and/or in any other
              jurisdiction subject to applicable laws. We collect, store, share
              and process Your Personal and non-Personal Information for the
              following purpose:
            </p>
            <h4>1. Communication:</h4>
            <p>
              We may use Your Personal to communicate with You about Your
              account, transactions, or inquiries, as well as to send You
              important updates or notifications about Our services.
            </p>
            <h4>2. Personalization:</h4>
            <p>
              Your Personal and non-Personal Information helps Us personalize
              Your experience and tailor Our services to Your preferences and
              interests. This may include customizing content, offers, or
              recommendations.
            </p>
            <h4>3. Improvement and Development:</h4>
            <p>
              {" "}
              We analyse Your Personal and non-Personal Information to improve
              Our services, and Website functionality, as well as to develop new
              features and offerings.
            </p>
            <h4>4. Marketing and Promotions:</h4>
            <p>
              With Your consent, We may use Your Personal Information to send
              You marketing communications, promotions, or surveys that We
              believe may be of interest to You.
            </p>
            <h4>5. Compliance and Legal Obligations:</h4>
            <p>
              We may process Your Personal and non-Personal Information to
              comply with applicable laws, regulations, legal processes, or
              contractual obligations, as well as to protect Our and Your public
              rights or safety.
            </p>
            <h4>6. Security:</h4>
            <p>
              Your Personal and non-Personal Information is used to maintain and
              enforce information security protocols, identify potential
              security breaches, malware, or computer viruses, and to
              investigate, prevent, or address unlawful activities and suspected
              instances of fraud.
            </p>
            <h4>7. Research and Analytics:</h4>
            <p>
              We may use Your Personal and non-Personal Information for research
              purposes, such as analysing trends, demographics, or user
              behaviour, to better understand You and improve Our services.
            </p>
            <h4>8. Responding to Queries:</h4>
            <p>
              Your Personal Information enables Us to process and respond to any
              queries or requests You may have regarding the services provided
              by us.
            </p>
            <h4>9. Policy Amendments: </h4>
            <p>
              Your Personal and non-Personal Information allows Us to inform You
              about any amendments to Our policies, ensuring transparency and
              compliance with applicable regulations.
            </p>
            <h4>10. Initiatives:</h4>
            <p>
              To allow You to participate in interactive features offered
              through Our Website.
            </p>
            <h4>11. Others:</h4>
            <p>
              In any other way We may describe when You provide the Information.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Sharing transfer or disclosure of Your Information</h3>
            <p>
              We understand the importance of keeping Your Personal and
              non-Personal Information confidential and We are committed to
              safeguarding it. However, there are circumstances where We may
              need to share, transfer, or disclose Your Personal and
              non-Personal Information with certain third parties, vendors,
              affiliates, pick-up partners, etc., for legitimate purposes. The
              following are the circumstances in which We may share Your
              Personal Information:
            </p>
            <h4>1. Third-Party Service Providers:</h4>
            <p>
              We may engage third-party service providers to assist Us in
              providing services to You. These service providers may have access
              to Your Personal Information, but only to the extent necessary to
              perform their functions on Our behalf. We ensure that these
              service providers adhere to strict confidentiality and security
              standards.
            </p>
            <h4>2. Payment Processing:</h4>
            <p>
              We may require Your financial information to authentical and
              facilitate the processing of payments to You. This will be done
              solely to finalize transactions and fulfil Our contractual
              obligations. Your Personal Information may be shared with a
              Reserve Bank of India authorized Payment Aggregator/Payment
              gateway or any third party for processing payment on Our behalf.
              Please note that We shall in no circumstances be held responsible
              for any delay or failure in payment procession on their end,
              whether it impacts You or any third party.
            </p>
            <h4>3. Legal Compliance:</h4>
            <p>
              We may disclose Your Personal Information when We are required to
              comply with applicable laws, regulations, legal processes, or
              government requests. This includes sharing Your Personal and
              non-Personal Information with law enforcement agencies, regulatory
              authorities, or other government bodies when necessary to protect
              Our rights, property, or safety, or that of Our users or the
              public.
            </p>
            <h4>4. Business Transfers:</h4>
            <p>
              In the event of a merger, acquisition, reorganization, or sale of
              assets, Your Personal and non-Personal Information may be
              transferred or disclosed as part of the transaction. We will
              ensure that any such transfer or disclosure complies with
              applicable data protection laws and regulations.
            </p>
            <h4>5. With Your Consent:</h4>
            <p>
              We may share or disclose Your Personal Information with Your
              explicit consent or as otherwise permitted by applicable laws and
              regulations.
            </p>
            <h4>6. Aggregated or De-Identified Data:</h4>
            <p>
              We may share aggregated or anonymous data that does not personally
              identify You for various purposes, including research, analytics,
              and marketing.
            </p>
            <h4>7. Advertising Partners:</h4>
            <p>
              We may share Your Personal and non-Personal Information with Our
              advertising partners to deliver personalized advertisements to
              You. However, We do not disclose Your Personal Information to Our
              advertising partners without Your explicit consent.
            </p>
            <h4>8. Other Circumstances: </h4>
            <p>
              We may share or disclose Your Personal Information in other
              circumstances not covered above, but only when necessary and
              appropriate, and in compliance with applicable laws and
              regulations. We may share Your Personal Information or non-
              Personal Information with Our service providers to monitor and
              analyse the use of Our Website.
            </p>
            <p>
              We take all reasonable steps to ensure that any sharing, transfer,
              or disclosure of Your Personal and non-Personal Information is
              conducted securely and in accordance with this Privacy Policy and
              applicable laws. If You have any questions or concerns about the
              sharing, transfer, or disclosure of Your Personal Information,
              please contact us.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Your Rights</h3>
            <p>
              You have followings rights with respect to Your Personal
              Information:
            </p>
            <h4>1. Access and Update:</h4>
            <p>
              You can access, review and update Your Personal Information
              directly through the functionalities provided on Our Website.
            </p>
            <h4>2. Correction and Deletion:</h4>
            <p>
              If You believe any of Your Personal Information is inaccurate,
              outdated or incomplete, You can request corrections or deletions.
              We will take reasonable steps to verify Your request and make the
              necessary changes.
            </p>
            <h4>3. Withdrawal of consent: </h4>
            <p>
              You have the right to withdraw Your consent to Our processing of
              Your Personal Information at any time. We request You to kindly
              send a written request at <a href="mailto:care@selsmart.in">care@selsmart.in</a> with “Withdrawal of
              Consent” in the subject line. We will verify Your request and
              process it in accordance with this Privacy Policy, Our Terms and
              Conditions and applicable laws. Please note that withdrawing
              consent may limit Your access and certain features of Our Website
              and/or services that rely on that information.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Cookies and WEB BEACON Cookies</h3>
            <p>
              To enhance Your experience and improve Our services, We use
              certain data collection tools like “cookies” on Our Website. These
              cookies help Us in analysing Website traffic patterns, assessing
              promotional activities, and building trust and security. Cookies
              are small files stored on Your computer, mobile device, tablet
              device etc, which enables Us to offer certain features and reduce
              the frequency of password prompts during a session. Please note
              that, cookies do not contain Personal Information but may provide
              targeted content based on how You use Our Website and Services.
            </p>
            <p>
              Most cookies, referred to as “session cookies” are automatically
              deleted at the end of Your browsing session. While You have the
              option to decline or delete Our cookies through Your browser
              settings, this may limit Your access to certain features of Our
              Website and services and necessitate more frequent password
              prompts during a session.
            </p>
            <p>
              Furthermore, You may encounter cookies or similar tracking tools
              from third parties on some pages of the Website, over which We
              have no control.
            </p>
            <p>
              We utilize cookies from third-party partners like Google Analytics
              for marketing and analytical purposes to better understand Your
              behaviour on Our Website. Google Analytics assists Us in analysing
              how You interact with Our Website. For more information on how
              Google utilizes Your Personal Information, You can review their
              Privacy Policy here:
              https://www.google.com/intl/en/policies/privacy/, and You can opt
              out of Google Analytics here:
              https://tools.google.com/dlpage/gaoptout.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Data Retention</h3>
            <p>
              We will only retain Your Personal Information and non-Personal
              Information for as long as it is necessary for Us to fulfil the
              purpose for which it was collected or as required by law. However,
              We may retain data related to You if there is a legal obligation
              to retain the data; if required to comply with any applicable
              statutory or regulatory retention requirement by law; if We
              believe it may be necessary to prevent fraud or future abuse; to
              enable Us to exercise Our legal rights and/or defend against legal
              claims; or for other legitimate purposes. We may continue to
              retain Your data in anonymised form for analytical and research
              purposes.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Security Safegaurds</h3>
            <p>
              We take the security of Your Personal and non-Personal Information
              very seriously. We are committed to protecting Your information
              using industry standard security practices and procedures. These
              practices include a combination of technical, operational,
              managerial, and physical controls designed to safeguard Your
              information from unauthorized access, disclosure or alteration
              while it is in Our possession and control.
            </p>
            <p>
              While We strive to keep Your information secure, it is important
              to understand that no internet transmission or electronic storage
              method is 100% secure. By using Our Website You acknowledge that
              We cannot be held liable in any manner for the loss of Your
              information due to any force majeure event and We cannot guarantee
              absolute security of Your information. By using Our services, You
              acknowledge that any information You transmit to Us, including
              Personal Information, is done at Your own risk.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Minors</h3>
            <p>
              Our Website and the services We offer through Our Website are
              intended for the users who are able to enter into a legally
              binding contract under the Indian Contract Act, 1872. We do not
              knowingly solicit or collect Personal Information from individuals
              under the age of 18 years. Individuals under the age of 18 years
              may access the Website or its contents only under the supervision
              and with prior consent of a parent or guardian.
            </p>
          </div>

          <div className="privacy-cookies-section">
            <h3>Grievance Officer</h3>
            <p>
              In the event of any complaint relating to any terms of this
              Privacy Policy or processing, storing and retention of Your
              Personal Information by Us, You may contact Our grievance officer
              at the below-mentioned details by writing “Grievance” in the
              subject:
              <br />
              Email Id: <a href="mailto:care@selsmart.in">care@selsmart.in</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyAndCookiesPage;
 
